var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeView == 'tickets')?_c('tickets-list',{attrs:{"is_grouped":true}}):_c('div',[_vm._v(_vm._s(_vm.localization("app-vault", "Vault")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }